
import React, { useState } from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	TextField,
	FormControl,
	InputLabel,
	FormHelperText,
	Select,
	Button,
	Stack,
	Box,
} from '@mui/material';

import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import AdapterMoment from '@date-io/moment';
import moment from 'moment';

// import { GenreList, ContentRatings } from '../reducers/filterReducer';

const defaultFormData = {
	videoLink: '',
	previewImage: '',
	title: '',
	genre: '',
	contentRating: '',
	releaseDate: moment().format('MM/DD/YYYY'),
};

export default function UploadVideoDialog(props) {
	const [formData, setFormData] = useState(defaultFormData);

	function handleChange({ target: { name, value } }) {
		setFormData({ ...formData, [name]: value });
	}

	function handleSubmit(e) {
		e.preventDefault();
	}

	function getPropsFor(field) {
		return {
			onChange: handleChange,
			name: field,
			value: formData[field],
		};
	}

	return (
		<Dialog {...props}>
			<DialogTitle>Upload Video</DialogTitle>
			<DialogContent>
				<Stack spacing={3} pt={2} component='form' onSubmit={handleSubmit}>
					<TextField
						fullWidth
						label='Video Link'
						helperText='This Link will be used to derive the video'
						{...getPropsFor('videoLink')}
						id='upload-btn-video'
					/>
					<TextField
						fullWidth
						label='Thumbnail Image Link'
						helperText='This Link will be used to preview the thumbnail image'
						{...getPropsFor('previewImage')}
						id='upload-btn-image'
					/>
					<TextField
						fullWidth
						label='Title'
						helperText='The Title will be the representative text for the video'
						name='title'
						onChange={handleChange}
						{...getPropsFor('title')}
						id='upload-btn-title'
					/>
					<FormControl fullWidth id='upload-btn-genre'>
						<InputLabel>Genre</InputLabel>
						<Select label='Genre' {...getPropsFor('genre')}>
							{/* {GenreList.map((genre, i) => (
								<MenuItem value={genre} key={i}>
									{genre}
								</MenuItem>
							))} */}
						</Select>
						<FormHelperText>
							Genre will help in categorizing your videos
						</FormHelperText>
					</FormControl>

					<FormControl fullWidth id='upload-btn-content-rating'>
						<InputLabel>Suitable Age Group for the video</InputLabel>
						<Select
							label='Suitable Age Group for the video'
							{...getPropsFor('contentRating')}
						>
							{/* {ContentRatings.map((ageGrp, i) => (
								<MenuItem value={ageGrp} key={i}>
									{ageGrp}
								</MenuItem>
							))} */}
						</Select>
						<FormHelperText>
							This will be used to filter videos based on age group
						</FormHelperText>
					</FormControl>
					<LocalizationProvider dateAdapter={AdapterMoment}>
						<MobileDatePicker
							label='Release Date'
							inputFormat='MM/DD/YYYY'
							renderInput={params => (
								<TextField
									helperText='This will be used to sort the videos'
									{...params}
								/>
							)}
							{...getPropsFor('releaseDate')}
							onChange={releaseDate =>
								setFormData({ ...formData, releaseDate })
							}
							id='upload-btn-release-date'
						/>
					</LocalizationProvider>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
						}}
					>
						<Button
							variant='contained'
							color='error'
							type='submit'
							id='upload-btn-submit'
						>
							Upload
						</Button>
						<Button
							sx={{ color: 'common.white', ml: 2 }}
							onClick={props.onClose}
							type='button'
							id='upload-btn-cancel'
						>
							Cancel
						</Button>
					</Box>
				</Stack>
			</DialogContent>
		</Dialog>
	);
}